import { LOGOUT, RECEIVE_INITIAL_STATE } from "@/components/access/ducks/Actions"
import {
  CLEAR_AFFINITY_SUGGESTIONS,
  CLEAR_INDUSTRY_SUGGESTIONS,
  CLOSE_PROFILE_AVATAR,
  OPEN_PROFILE_AVATAR,
  RECEIVE_AFFINITY_SUGGESTIONS,
  RECEIVE_INDUSTRY_SUGGESTIONS,
  RECEIVE_UPDATE_USER,
  RECEIVE_UPDATE_USER_CONSTITUENT,
  TOGGLE_EDIT_PROFILE_OFF,
  TOGGLE_EDIT_PROFILE_ON,
  TOGGLE_PROFILE_DRAWER_SAVING_OFF,
  TOGGLE_PROFILE_DRAWER_SAVING_ON,
} from "@/components/profile/ducks/Actions"
import { CLEAR_SELECTED_USER } from "@/components/search/ducks/Actions"
import { WelcomeUserActions } from "@/components/welcome/ducks/slice"

const defaultState = {
  affinitySuggestions: [],
  industrySuggestions: [],
  saving: false,
  profileAvatarOpen: false,
  showEditContactInfo: false,
  currentUser: {},
  currentConstituent: null,
}

const userProfileReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_UPDATE_USER:
      return {
        ...oldState,
        currentUser: action.currentUser,
      }

    case RECEIVE_UPDATE_USER_CONSTITUENT:
      return {
        ...oldState,
        currentConstituent: action.currentConstituent,
      }

    case RECEIVE_AFFINITY_SUGGESTIONS:
      return {
        ...oldState,
        affinitySuggestions: action.affinitySuggestions,
      }

    case CLEAR_AFFINITY_SUGGESTIONS:
      return {
        ...oldState,
        affinitySuggestions: [],
      }

    case RECEIVE_INDUSTRY_SUGGESTIONS:
      return {
        ...oldState,
        industrySuggestions: action.suggestions,
      }

    case CLEAR_INDUSTRY_SUGGESTIONS:
      return {
        ...oldState,
        industrySuggestions: [],
      }

    case TOGGLE_PROFILE_DRAWER_SAVING_ON:
      return {
        ...oldState,
        saving: true,
      }

    case TOGGLE_PROFILE_DRAWER_SAVING_OFF:
      return {
        ...oldState,
        saving: false,
      }

    case OPEN_PROFILE_AVATAR:
      return {
        ...oldState,
        profileAvatarOpen: true,
      }

    case CLOSE_PROFILE_AVATAR:
      return {
        ...oldState,
        profileAvatarOpen: false,
      }

    case TOGGLE_EDIT_PROFILE_ON:
      return {
        ...oldState,
        showEditContactInfo: true,
      }

    // HANDLED by middleware
    // case CLEAR_SUFFIX_LINK:
    // case NavigationActions.clearSuffixLink.type:
    //   return {
    //     ...oldState,
    //     showEditContactInfo: false,
    //   }

    case CLEAR_SELECTED_USER:
      return {
        ...oldState,
        showEditContactInfo: false,
      }

    case TOGGLE_EDIT_PROFILE_OFF:
      return {
        ...oldState,
        showEditContactInfo: false,
      }

    // case RECEIVE_ANNOUNCEMENTS_TOGGLE_SUCCESS:
    case WelcomeUserActions.markAnnouncementsSeen.fulfilled.type:
      return {
        ...oldState,
        // currentUser: action.currentUser,
        currentUser: action.payload.currentUser,
      }

    case RECEIVE_INITIAL_STATE: {
      const { currentUser, currentUserIsAdmin, customer } = action.response
      const customerId = customer?.id
      const currentUserWithCurrentAdmin =
        typeof currentUserIsAdmin === "boolean" && customerId
          ? {
              ...currentUser,
              organizationSettings: {
                ...currentUser.organizationSettings,
                isAdmin: {
                  ...currentUser.organizationSettings?.isAdmin,
                  [customerId]: currentUserIsAdmin,
                },
              },
            }
          : currentUser

      return {
        ...oldState,
        currentUser: currentUserWithCurrentAdmin,
        currentConstituent: action.response.currentConstituent,
      }
    }

    default:
      return oldState
  }
}

export default userProfileReducer
